import { render } from "./MaterialIcon.vue?vue&type=template&id=2f3040f5&scoped=true"
import script from "./MaterialIcon.vue?vue&type=script&lang=js"
export * from "./MaterialIcon.vue?vue&type=script&lang=js"

import "./MaterialIcon.vue?vue&type=style&index=0&id=2f3040f5&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3040f5"]])

export default __exports__